export enum QuotingRole {
  Undetermined,
  Admin,
}
